import { render, staticRenderFns } from "./reagentMallApplicationPre.vue?vue&type=template&id=6bc0167a&scoped=true"
import script from "./reagentMallApplicationPre.vue?vue&type=script&lang=js"
export * from "./reagentMallApplicationPre.vue?vue&type=script&lang=js"
import style0 from "./reagentMallApplicationPre.vue?vue&type=style&index=0&id=6bc0167a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0167a",
  null
  
)

export default component.exports